export default {
  stats: {
    table: {
      rank: "Ranking",
      name: "Nombre",
    },
    legend: {
      title: "Leyenda",
    },
    filters: {
      titles: {
        week: "Semana",
        round: "Ronda",
        split: "División",
      },
      options: {
        all: "Todo",
        qualifier: {
          cumulativeStats: "Totales",
          perGame: "Por partido",
        },
      },
    },
  },
};